import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutHalfFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-half-full"} maskId="square-filled-radius-0-stroke-1-IconLayoutHalfFull"><path d="M3 11.5V3H21V11.5H3Z" fill="currentColor"/><path d="M3 12.5V21H21V12.5H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutHalfFull;
